<div class="content-main-container">
    <mat-card class="article-card">
        <mat-card-header>
            <mat-card-title>
                <div class="main-title">
                    {{ card?.title }}
                </div>
            </mat-card-title>
        </mat-card-header>
        <mat-divider></mat-divider>
        <div fxLayout="row wrap" fxLayoutAlign="center" class="chip_area">
            <mat-chip-list *ngFor="let t of card?.tags">
                <mat-chip  [ngStyle]="chipStyle(card?.type)" selected>{{ t | translate }}</mat-chip>
            </mat-chip-list>
        </div>
        <div *ngIf="card?.img" class="img_space">
            <img class="image_area" [src]="card?.img">
        </div>
        <div class="link_area">
            <button *ngIf="card?.hp"
                (click)="goPublicSite()"
                mat-raised-button 
                color="primary">
                <mat-icon>open_in_new</mat-icon>
                {{ linkBtnLabel | translate }}
            </button>
            <div fxLayout="row wrap" fxLayoutAlign="center">
                <a *ngIf="card?.tell" href="tel:{{card.tell}}">
                    <img class="logo" src="assets/img/logo/tellephone.svg">
                </a>
                <a *ngIf="card?.mail" href="mailto:{{card.mail}}">
                    <img class="logo" src="assets/img/logo/mail.svg">
                </a>
                <img *ngIf="card?.fb" (click)="goFacebook()" class="logo" src="assets/img/logo/fb_logo.png">
                <img *ngIf="card?.tw" (click)="goTwitter()"class="logo" src="assets/img/logo/tw_logo.png">
                <img *ngIf="card?.line" (click)="goLine()"class="logo" src="assets/img/logo/line_logo.png">
                <img *ngIf="card?.insta" (click)="goInstagram()"class="logo" src="assets/img/logo/insta_logo.png">
            </div>
        </div>
        <mat-card-content>
            <div class="detail_area">
                <h3 translate>facility.philosophy</h3>
                <span>{{ card?.philosophy }}</span>
                <h3 translate>facility.contents</h3>
                <span>{{ card?.contents }}</span>
                <h3 *ngIf="card?.howto" translate>facility.how_to_use</h3>
                <span>{{ card?.howto }}</span>
                <h3 *ngIf="card?.hour" translate>facility.bussiness_hours</h3>
                <span>{{ card?.hour }}</span>
                <h3 *ngIf="card?.fee" translate>facility.fee</h3>
                <span>{{ card?.fee }}</span>
                <h3 *ngIf="card?.others" translate>facility.others</h3>
                <span>{{ card?.others }}</span>
                <h3 *ngIf="card?.address" translate>facility.address</h3>
                <span>{{ card?.address }}</span>
            </div>
        </mat-card-content>
    </mat-card>
    <div class="goback_btn">
        <button 
            (click)="goBack()"
            mat-raised-button 
            color="primary">
            <mat-icon>arrow_back</mat-icon>
            {{ gobackBtnLabel | translate }}
        </button>
    </div>
</div>